import React from 'react';
import PropTypes from 'prop-types';
import {
  IconButton,
  MenuItem,
  TableBody,
  TableCell,
  TableRow,
  Box,
  Chip,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { Controls } from '../../../components/controls/Controls';
import useTable from '../../../components/useTable';

const header = [
  { id: 'appointmentTypeID', label: 'Appointment Type ID' },
  { id: 'appointmentType', label: 'Appointment Type' },
  { id: 'intakePlan', label: 'Intake Plan' },
  { id: 'deleteType', label: 'Remove' },
];

export default function AppointmentTypeTable(props) {
  const { selectedPlans, appointmentPlanPairs, setAppointmentPlanPairs } = props;

  const deleteType = (id) => {
    setAppointmentPlanPairs(appointmentPlanPairs.filter((item) => item.id !== id));
  };

  const handleSelectChange = (event) => {
    const newSelectedPlan = event.target.value.option;
    const newSelected = appointmentPlanPairs.map((obj) => {
      if (obj.name === event.target.name) {
        if (newSelectedPlan) {
          return { ...obj, intakePlanId: newSelectedPlan.id };
        }
        return { ...obj, intakePlanId: null };
      }
      return obj;
    });
    setAppointmentPlanPairs(newSelected);
  };

  const {
    TblContainer,
    TblHead,
    currentPageDataSorted,
  } = useTable(appointmentPlanPairs, header, { fn: (items) => items });

  return (
    <TblContainer>
      <TblHead />
      <TableBody>
        {appointmentPlanPairs && currentPageDataSorted().map((appointmentType) => (
          <TableRow key={appointmentType.id}>
            <TableCell>{appointmentType.id}</TableCell>
            <TableCell>{appointmentType.name}</TableCell>
            <TableCell>
              <Controls.Select
                sx={{ minWidth: '400px', maxWidth: '400px' }}
                label="Value"
                name={appointmentType.name}
                value={appointmentPlanPairs}
                onChange={handleSelectChange}
                renderValue={() => {
                  if (appointmentType.intakePlanId) {
                    const plan = selectedPlans.find(
                      (item) => item.id === appointmentType.intakePlanId,
                    );
                    if (plan) {
                      return (
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                          <Chip key={appointmentType.type} label={`${plan.referenceCode} [${plan.moduleName}]`} />
                        </Box>
                      );
                    }
                    return <Box />;
                  }
                  return <Box />;
                }}
              >
                <MenuItem key="None" value={{ option: null }}>
                  None
                </MenuItem>
                {selectedPlans && selectedPlans.map((option) => (
                  <MenuItem key={option.referenceCode} value={{ option }}>
                    { `${option.referenceCode} [${option.moduleName}]` }
                  </MenuItem>
                ))}
              </Controls.Select>
            </TableCell>
            {appointmentType.id !== 'default' && appointmentType.name !== 'default'
              ? (
                <TableCell>
                  <IconButton onClick={() => deleteType(appointmentType.id)}>
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              )
              : (<TableCell />)}
          </TableRow>
        ))}
      </TableBody>
    </TblContainer>
  );
}

AppointmentTypeTable.propTypes = {
  setting: PropTypes.shape({
    name: PropTypes.string.isRequired,
    category: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  }).isRequired,
  selectedPlans: PropTypes.arrayOf(
    PropTypes.shape({
      actionListId: PropTypes.number,
      id: PropTypes.number,
      isIntakePlan: PropTypes.bool,
      languagesToTranslate: PropTypes.arrayOf(PropTypes.string),
      uniqueName: PropTypes.string,
    }),
  ).isRequired,
  appointmentPlanPairs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      intakePlanId: PropTypes.string,
    }),
  ).isRequired,
  setAppointmentPlanPairs: PropTypes.func.isRequired,
};
